import CryptoJS from "crypto-js";
import { User } from "./user.ts";

export interface Patient {
  id: string;
  name: string;
  lastImport: Date | null;
}

export interface PatientRecordEncryptedPart {
  name: string;
}

//the record stored in the DB. data is encrypted with the user key
export interface PatientRecord {
  userId: string;
  id: string;
  lastImport: Date | null;
  encryptedPart: PatientRecordEncryptedPart;
}

export const encryptPatient = (patient: Patient, user: User) => {
  const key = user.cypherKey.map((byte) => String.fromCharCode(byte)).join("");
  const name = CryptoJS.AES.encrypt(patient.name, key).toString();
  const patientRecord: PatientRecord = {
    id: patient.id,
    userId: user.userId,
    lastImport: patient.lastImport,
    encryptedPart: {
      name,
    },
  };
  return patientRecord;
};

export const decryptPatientRecord = (data: PatientRecord, user: User) => {
  const key = user.cypherKey.map((byte) => String.fromCharCode(byte)).join("");
  const { id, lastImport, encryptedPart } = data;
  const name = CryptoJS.AES.decrypt(encryptedPart.name, key).toString(
    CryptoJS.enc.Utf8,
  );
  const patient: Patient = {
    id,
    name,
    lastImport,
  };
  return patient;
};
